import { PhotoIcon, PlusIcon } from '@heroicons/react/20/solid';

import classNames from '../../lib/classNames';
import { MAX_FILES, useImageUpload } from '../../lib/image-upload';

import ImagePreview from './ImagePreview';

export default function UploadImages({ disabled }: { disabled: boolean }) {
  const { files, error, errors, getRootProps, getInputProps, deleteImage } = useImageUpload(
    disabled,
    'pictures'
  );

  return (
    <section className="container">
      <div
        {...getRootProps({
          className: classNames(
            disabled ? 'pointer-events-none backdrop-sepia-0 bg-white/30' : '',
            'flex flex-col m-auto overflow-auto items-center justify-center w-full p-4 h-[31vh] border-dashed border-2 rounded-md text-center border-gray-300 dark:border-gray-600'
          )
        })}
      >
        <input {...getInputProps()} />
        <div className="flex flex-col items-center">
          {!files?.length && (
            <>
              {!disabled && (
                <>
                  <div className="m-auto text-xl text-gray-600 dark:text-gray-400">
                    Перетащите или загрузите фотографии
                  </div>
                  <div className="m-auto text-xl text-gray-600 dark:text-gray-400">
                    {`Максимум ${MAX_FILES} фотографий`}
                  </div>
                </>
              )}
              <PhotoIcon width={80} className="fill-gray-400 dark:fill-gray-600" />
            </>
          )}
        </div>
        <div className="flex h-full flex-wrap justify-center gap-2">
          {files?.map((file) => (
            <ImagePreview key={file.id} file={file} onDelete={deleteImage} />
          ))}
          {!!files?.length && !disabled && (
            <div className="relative inline-flex cursor-pointer items-center rounded-md border-2 border-gray-300 p-1 dark:border-gray-600">
              <PlusIcon width={130} height={60} className="fill-gray-400 dark:fill-gray-600" />
            </div>
          )}
        </div>
        {error && <p className="text-red-600 dark:text-red-400">{error}</p>}
      </div>
      <p className="text-red-600 dark:text-red-400">{errors['pictures']?.message as string}</p>
    </section>
  );
}
